import $ from 'jquery';
/* ===============================================================
Form contacts class
=============================================================== */
class Tips {
    // Initialize
    constructor() {
        this.holder = $('.irantheme-tips-holder');
        this.events();
    }

    // Events
    events() {}

    // Create a new tip
    createTip(type, message, millisecond = 5000, extra_html = '') {
        let classType = '';
        // Holder of icon tag
        let iconTag = '';
        // Check type of tip
        switch (type) {
            // Success type
            case 'success':
                classType = 'irantheme-tip-success';
                iconTag =
                    '<i class="fa-light fa-badge-check irantheme-tip-icon"></i>';
                break;
            // Info type
            case 'info':
                classType = 'irantheme-tip-info';
                iconTag =
                    '<i class="fa-light fa-seal-question irantheme-tip-icon"></i>';
                break;
            // Warning type
            case 'warning':
                classType = 'irantheme-tip-warning';
                iconTag =
                    '<i class="fa-light fa-badge-percent irantheme-tip-icon"></i>';
                break;
            // Error type
            case 'error':
                classType = 'irantheme-tip-error';
                iconTag =
                    '<i class="fa-light fa-seal-exclamation irantheme-tip-icon"></i>';
                break;
        }
        // Holder of new tip element
        let newTipElement = `
        <div class="irantheme-tip ${classType}" style="display:none;">
            <!-- Icon -->
            ${iconTag}
            <!-- Note -->
            <p class="irantheme-tip-note">${message}${extra_html}</p>
            <div class="irantheme-tip-timer">
                <!-- Timer -->
                <div class="irantheme-tip-timer-counter"></div>
            </div>
        </div>
        `;

        // Append new tip created to holder of tips
        $(newTipElement).appendTo(this.holder).slideDown(500);
        // Init timer of counter added
        this.initTimer(millisecond);
        // Hide tip after delay
        this.hideTipsAndDestroy(millisecond);
    }

    // Init timer
    initTimer(millisecond) {
        // Get all new created tips counters
        let allTips = this.holder.find(
            '.irantheme-tip .irantheme-tip-timer .irantheme-tip-timer-counter:not(.irantheme-tip-init)',
        );
        // add init class to tip for prevent to twice initialization
        allTips.addClass('irantheme-tip-init');

        // Animate each timer counter
        allTips.each((index, element) => {
            const $counter = $(element);
            const startTime = Date.now();
            const endTime = startTime + millisecond;

            // Set initial width to 100%
            $counter.css('width', '100%');

            // Function to update width based on remaining time
            const updateWidth = () => {
                const now = Date.now();
                const remaining = Math.max(0, endTime - now);
                const percentage = (remaining / millisecond) * 100;

                $counter.css('width', `${percentage}%`);

                if (remaining > 0) {
                    requestAnimationFrame(updateWidth);
                }
            };

            // Start the animation
            requestAnimationFrame(updateWidth);
        });
    }

    // Hide tips and destroy (Remove tag)
    hideTipsAndDestroy(millisecond) {
        // Get all new created tips counters
        let allTips = this.holder.find(
            '.irantheme-tip:not(.irantheme-tip-init-hide)',
        );
        allTips.addClass('.irantheme-tip-init-hide');
        $(allTips).each(function (index, element) {
            setTimeout(() => {
                $(element).slideUp(250);
            }, millisecond);
            setTimeout(() => {
                $(element).remove();
            }, millisecond + 500);
        });
    }
}

export default Tips;
